<template>
  <section class="main-goal">
    <div :class="`main-goal__block main-goal__block--${className}`">
      <div class="main-goal__block_content">
        <h3 v-html="title" />

        <div
          v-for="(cheapItem, index) in cheap"
          :key="index"
          class="main-goal__block_cheap"
        >
          <p>{{ cheapItem.title }}</p>
          <div class="main-goal__block_cheap_items">
            <template v-for="(item, idx) in cheapItem.items">
              <nuxt-link
                v-if="item.to"
                :key="idx"
                :class="{ hovered: item.hovered }"
                :to="item.to"
                v-html="item.text"
              />
              <button
                v-if="item.modal"
                :key="idx"
                :class="['m-btn', { hovered: item.hovered }]"
                @click="openModal(item.modal, item.text)"
                v-html="item.text"
              />
            </template>
          </div>
        </div>
      </div>

      <main-goal-video
        v-if="videos[currentVideoIndex]"
        class="main-goal__block_video"
        :videos-count="videos.length"
        :video="videos[currentVideoIndex]"
        :video-number="currentVideoIndex + 1"
        @next="nextVideo"
        @play="currentVideoIndex = $event - 1"
      />
    </div>

    <other-school-goal-banner v-if="semeinoePage" />
    <!--<school-new-goal-banner v-else />-->
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import MainGoalVideo from '../main/MainGoalVideo.vue';
import { MODAL_TYPES } from '../common/AppHeader/data';
// import SchoolNewGoalBanner from './SchoolNewGoalBanner.vue';
import OtherSchoolGoalBanner from './other/OtherSchoolGoalBanner.vue';

export default {
  name: 'SchoolNewGoal',
  components: {
    OtherSchoolGoalBanner,
    // SchoolNewGoalBanner,
    MainGoalVideo,
  },
  data: () => ({
    className: 'orange',
    title: 'школа, которая <br>подходит всем',

    // cheap: [
    //   {
    //     id: 1,
    //     title: 'общеобразовательные классы',
    //     items: [
    //       { text: '5 класс', to: '/online-school/5-klass' },
    //       { text: '6 класс', to: '/online-school/6-klass' },
    //       { text: '7 класс', to: '/online-school/7-klass' },
    //       { text: '8 класс', to: '/online-school/8-klass' },
    //       { text: '9 класс', to: '/online-school/9-klass' },
    //       { text: '10 класс', to: '/online-school/10-klass' },
    //       { text: '11 класс', to: '/online-school/11-klass' },
    //     ],
    //   },
    //   {
    //     id: 2,
    //     title: 'профильные классы',
    //     items: [
    //       { text: 'гуманитарный', to: '/online-school/gumanitarnyj' },
    //       { text: 'физмат', to: '/online-school/fiziko-matematicheskij' },
    //       { text: 'лингвистический', to: '/online-school/lingvisticheskij' },
    //       { text: 'соц. экономический', to: '/online-school/socialno-ekonomicheskij' },
    //     ],
    //   },
    //   {
    //     id: 3,
    //     title: 'для тех, кто хочет',
    //     items: [
    //       { text: 'закончить быстрее', to: '/externat' },
    //       { text: 'прикрепиться к школе', to: '/online-school/attestacii-i-prikreplenie' },
    //       { text: 'перевестись из другой школы', modal: MODAL_TYPES.transfer },
    //     ],
    //   },
    // ],
    videos: [
      {
        name: 'Сергунин Егор',
        about: 'ученик 11А класса',
        // eslint-disable-next-line max-len,vue/max-len
        text: 'являюсь профессиональным спортсменом по&nbsp;плаванию, сборная Краснодарского края. Учась в&nbsp;обычной школе, я&nbsp;бы ничего не&nbsp;успел',
        video: '/v2/main/goal/Сергунин Егор.mp4',
        duration: 115,
      },
      {
        name: 'Дарья Андриевская',
        about: 'закончила 11 класса',
        // eslint-disable-next-line max-len,vue/max-len
        text: 'у меня возник конфликт в прошлой школе, недопонимание и мы с моей мамой решили, что заберем заявление. В итоге выбрали Синергию, комфортное зачисление и очень приятные преподаватели',
        video: '/v2/main/goal/Дарья Андриевская.mp4',
        duration: 34,
      },
      {
        name: 'Оля',
        about: 'ученица 10А класса',
        // eslint-disable-next-line max-len,vue/max-len
        text: 'уроки были не&nbsp;только информативные, но&nbsp;еще&nbsp;и&nbsp;интересные, учителя старались найти подход к&nbsp;каждому ученику, стараясь объяснить так, чтобы&nbsp;все&nbsp;поняли',
        video: '/v2/main/goal/Оля.mp4',
        duration: 22,
      },
      {
        name: 'Рома',
        about: 'ученик 9Е класса',
        text: 'учителя учат жить, а не просто дают знания',
        video: '/v2/main/goal/Рома.mp4',
        duration: 49,
      },
    ],
    currentVideoIndex: 0,
  }),

  computed: {
    cheap() {
      return [
        {
          id: 1,
          title: 'общеобразовательные классы',
          items: [
            { text: 'дошкольники', modal: MODAL_TYPES.preschooler },
            { text: '1-4 класс', modal: MODAL_TYPES.preschooler },
            { text: '5 класс', to: '/online-school/5-klass' },
            { text: '6 класс', to: '/online-school/6-klass' },
            { text: '7 класс', to: '/online-school/7-klass' },
            { text: '8 класс', to: '/online-school/8-klass' },
            { text: '9 класс', to: '/online-school/9-klass' },
            { text: '10 класс', to: '/online-school/10-klass' },
            { text: '11 класс', to: '/online-school/11-klass' },
            { text: 'гуманитарный', to: '/online-school/gumanitarnyj' },
            { text: 'физмат', to: '/online-school/fiziko-matematicheskij' },
            { text: 'лингвистический', to: '/online-school/lingvisticheskij' },
            { text: 'соц. экономический', to: '/online-school/socialno-ekonomicheskij' },
          ].map((item) => {
            if (this.ceny2Page) {
              return {
                text: item.text,
                modal: MODAL_TYPES.moreProfil,
              };
            }

            return item;
          }),
        },
        {
          id: 2,
          title: 'для тех, кто хочет',
          items: [
            {
              text: 'закончить быстрее',
              ...this.ceny2Page ? { modal: MODAL_TYPES.schoolExternal } : { to: '/externat' },
            },
            { text: 'прикрепиться к школе', modal: MODAL_TYPES.prikrep },
            { text: 'сдать аттестацию', modal: MODAL_TYPES.onlineAttestacia },
            { text: 'перейти на СО', modal: MODAL_TYPES.familyDevelopment },
            { text: 'перевестись из другой школы', modal: MODAL_TYPES.transfer },
          ],
        },
      ];
    },

    ceny2Page() {
      return this.$route.name === 'online-school-ceny-2'
        || this.$route.name === 'online-school-ceny-dubai'
        || this.$route.name === 'online-school-ceny-3';
    },
    semeinoePage() {
      return this.$route.name === 'online-school-semeinoe-obuchenie'
        || this.$route.name === 'online-school-semeinoe-obuchenie-ceny';
    },
  },

  mounted() {
    // https://jr.synergy.ru/browse/ESK-4295
    // if (this.ceny2Page) {
    //   this.cheap = this.cheap.map((cheapItem) => {
    //     const items = cheapItem.items.map((item) => ({
    //       ...item,
    //       to: null,
    //       modal: cheapItem.id === 3 ? MODAL_TYPES.freeConsult : MODAL_TYPES.moreProfil,
    //     }));
    //
    //     return {
    //       ...cheapItem,
    //       items,
    //     };
    //   });
    // }
  },

  methods: {
    ...mapActions('appHeaderModals', {
      storyOpenModal: 'openModal',
      setModalComment: 'setModalComment',
    }),

    openModal(modalType, modalComment) {
      this.storyOpenModal(modalType);

      if (this.ceny2Page) {
        this.setModalComment(modalComment);
      }
    },

    /* eslint-disable no-param-reassign */
    nextVideo() {
      this.currentVideoIndex += 1;
      if (this.currentVideoIndex >= this.videos.length) {
        this.currentVideoIndex = 0;
      }

      if (this.videos.length === 1) {
        this.currentVideoIndex = null;
        this.$nextTick(() => {
          this.currentVideoIndex = 0;
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">

.main-goal {
  margin-bottom: calc(var(--scale) * 20);

  @include media-down($size-tablet) {
    margin-bottom: calc(var(--scale) * 8);
  }

  .main-goal__block {
    margin-bottom: calc(var(--scale) * 20);
    position: relative;
    display: flex;
    gap: calc(var(--scale) * 20);
    height: calc(var(--scale) * 720);

    @include media-down($size-tablet) {
      height: calc(var(--scale) * 512);
      margin-bottom: calc(var(--scale) * 8);
    }

    @include media-down($size-mobile) {
      height: calc(var(--scale) * 720);
    }

    .main-goal__block_content {
      width: calc(var(--scale) * 1375);
      border-radius: calc(var(--scale) * 60);
      padding: calc(var(--scale) * 32) calc(var(--scale) * 40) calc(var(--scale) * 40);

      background-size: cover;
      background-position: center;

      @include media-down($size-tablet) {
        width: 100%;
        border-radius: calc(var(--scale) * 32);
        padding:
          calc(var(--scale) * 20)
          calc(var(--scale) * 14)
          calc(var(--scale) * 16)
          calc(var(--scale) * 16);
      }
    }

    h3 {
      margin-bottom: calc(var(--scale) * 32);
      font-weight: 500;
      font-size: calc(var(--scale) * 112);
      line-height: 90%;
      letter-spacing: -0.04em;
      color: #FFFFFF;

      @include media-down($size-tablet) {
        margin-bottom: calc(var(--scale) * 28);
        max-width: calc(var(--scale) * 490);
        font-size: calc(var(--scale) * 44);
        line-height: 90%;
        letter-spacing: -0.06em;
      }

      @include media-down($size-mobile) {
        margin-bottom: calc(var(--scale) * 18);
        max-width: calc(var(--scale) * 250);
      }
    }

    .main-goal__block_cheap {
      @include media-down($size-tablet) {
        max-width: min(100%, calc(var(--scale) * 571));
      }

      &:not(:last-of-type) {
        margin-bottom: calc(var(--scale) * 28);

        @include media-down($size-tablet) {
          margin-bottom: calc(var(--scale) * 20);
        }
      }

      p {
        margin-bottom: calc(var(--scale) * 20);
        font-style: normal;
        font-weight: 500;
        font-size: calc(var(--scale) * 26);
        line-height: 120%;
        color: rgba(255, 255, 255, 0.5);

        @include media-down($size-tablet) {
          margin-bottom: calc(var(--scale) * 8);
          font-size: calc(var(--scale) * 18);
        }
      }

      &_items {
        display: flex;
        flex-wrap: wrap;
        gap: calc(var(--scale) * 4);
        position: relative;
        max-width: calc(var(--scale) * 950);
      }

      a,
      button {
        padding: calc(var(--scale) * 14) calc(var(--scale) * 28) calc(var(--scale) * 16);

        background-color: rgba(#ffffff, 0.15);
        border: 1px solid rgba(#ffffff, 0.5);
        box-shadow: inset 0 calc(var(--scale) * 5) calc(var(--scale) * 20) rgba(255, 255, 255, 0.15);
        backdrop-filter: blur(5px);
        border-radius: calc(var(--scale) * 16);
        outline: none;
        transition: 200ms;

        font-weight: 500;
        font-size: calc(var(--scale) * 20);
        line-height: 120%;
        color: #FFFFFF;

        @include media-down($size-tablet) {
          padding: calc(var(--scale) * 10) calc(var(--scale) * 16) calc(var(--scale) * 12);
          border-radius: calc(var(--scale) * 16);

          font-size: calc(var(--scale) * 16);
          letter-spacing: -0.02em;
          line-height: 110%;
        }

        &.nuxt-link-exact-active {
          cursor: default;
          background-color: #FFF0D1;
          color: #FF6726;
        }
      }
    }
  }

  .main-goal__block--orange {
    .main-goal__block_content {
      background-image: url("/v2/main/goal/orange.webp");

      @include media-down($size-tablet) {
        background-image: url("/v2/main/goal/orange-tablet.webp");
      }

      @include media-down($size-mobile) {
        background-image: url("/v2/main/goal/orange-mob.webp");
      }

      a:hover,
      button:hover {
        background-color: #FFF0D1;
        color: #FF5319;
      }
    }

    ::v-deep .video__text {
      background-color: #FFF0D1;
    }
  }

  .main-goal__block_video {
    width: calc(var(--scale) * 445);

    @include media-down($size-tablet) {
      position: absolute;
      width: calc(var(--scale) * 88);
      height: calc(var(--scale) * 120);
      top: calc(var(--scale) * 16);
      right: calc(var(--scale) * 16);
    }
  }
}

</style>
